module.exports = __webpack_public_path__ + "static/media/noImage.f151b4f9.svg";